<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Blurb-rw" epub:type="frontmatter" id="Blurb1">
<div class="title-block-rw" id="title-block3">
<p id="p3">“I meant it when I said that I’ve got you.”</p>
</div>
<p class="firstpara-rw" id="p4">With his free hand, Sean tucked a strand of hair behind Sierra’s ear, tracing his thumb over her cheekbone. His eyes drifted down to her lips, and he couldn’t fight it anymore. Clearly he was hell-bent on destruction tonight, because for the first time in his ten years as a bodyguard, he was going to kiss a client.</p>
<p id="p5">Cupping her cheek with his uninjured hand, he slowly dipped his head and gently, tenderly closed his mouth over hers. She responded immediately, returning the kiss with a soft sigh.</p>
<p id="p6">Finally he was touching her and tasting her just the way he’d wanted since the day they met. Finally, and it was a thousand times better than he ever could’ve imagined. And he’d spent a lot of time imagining it.</p>
<p id="p7">It was the best wrong thing he’d ever done.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-Blurb-01.vue?781c72de